{
  "title": "Sunu Produwe",
  "subtitle": "Xoolal sunu katalog te def sa komand.",
  "search_placeholder": "Seet ab produwe...",
  "filter_brand": "Marka",
  "filter_category": "Xeeti produwe",
  "categories": {
    "all": "Produwe yépp",
    "dairy": "Meew",
    "sauce": "Sos",
    "food": "Konseerw",
    "cleaning": "Setal",
    "rice": "Ceeb ak sëngal",
    "drink": "Naan"
  },
  "in_stock": "Am na",
  "out_of_stock": "Amul",
  "unit": "Bokk",
  "min_order": "Komand bu gën a ndaw",
  "price_from": "Tambali ci",
  "no_results": "Amul produwe bu ñu gis",
  "featured": "Produwe yu gën a jënd",
  "promotions": "Promosioŋ yi",
  "brand_page_title": "Produwe {{brand}}",
  "delivery_available": "Indil mën na am ci réew mi Dakar",
  "product_detail": "Xam-xam ci produwe bi",
  "description": "Tekki",
  "related_products": "Yeneen produwe yu la mën a neex",
  "back_to_catalog": "Dellu ci katalog bi",
  "brand_products": "Produwe {{brand}}",
  "sku": "Referaas",
  "weight": "Diis",
  "min_qty": "Limu bu gën a ndaw",
  "add_to_cart": "Yokk ci paañe bi",
  "added_to_cart": "Yokk na ci paañe bi",
  "low_stock": "Stock bi nekkul lu bari",
  "next_slide": "Nataal bi ci topp",
  "our_brands": "Sunu Marka yi",
  "prev_slide": "Nataal bi ci ginnaaw",
  "recently_viewed": "Yi nga seetoon mba noppi"
}
